import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import CampaignChannelSelectionPage from './pages/CampaignChannelSelectionPage.vue';
import LiveChatCampaignsPage from './pages/LiveChatCampaignsPage.vue';
import SMSCampaignsPage from './pages/SMSCampaignsPage.vue';
import WhatsAppCampaignTypeSelectionPage from './pages/WhatsAppCampaignTypeSelectionPage.vue';
import WhatsAppCampaignsPage from './pages/WhatsAppCampaignsPage.vue';
import WhatsAppCampaignCreatePage from './pages/WhatsAppCampaignCreatePage.vue';
import WhatsAppCampaignEditPage from './pages/WhatsAppCampaignEditPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          name: 'campaigns_index',
          meta,
          component: CampaignChannelSelectionPage,
        },
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_livechat_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_sms_index', params: to.params };
          },
        },
        {
          path: 'live_chat',
          name: 'campaigns_livechat_index',
          meta,
          component: LiveChatCampaignsPage,
        },
        {
          path: 'sms',
          name: 'campaigns_sms_index',
          meta,
          component: SMSCampaignsPage,
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignTypeSelectionPage,
        },
        {
          path: 'whatsapp/:inboxId/list',
          name: 'campaigns_whatsapp_list',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          redirect: to => ({
            name: 'campaigns_whatsapp_category_index',
            params: { ...to.params, campaignCategory: 'all' },
            query: { inbox_id: to.params.inboxId },
          }),
        },
        {
          path: 'whatsapp/new',
          name: 'campaigns_whatsapp_new',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignCreatePage,
        },
        {
          path: 'whatsapp/:campaignCategory(utility|marketing|all)',
          name: 'campaigns_whatsapp_category_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignsPage,
        },
        {
          path: 'whatsapp/:inboxId/:campaignId/edit',
          name: 'campaigns_whatsapp_edit',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignEditPage,
        },
      ],
    },
  ],
};

export default campaignsRoutes;
